import api from 'api'

export const GET_PRODUCTS = '[E-COMMERCE APP] GET PRODUCTS'
export const SET_PRODUCTS_SEARCH_TEXT = '[E-COMMERCE APP] SET PRODUCTS SEARCH TEXT'

export function getProducts() {
  return dispatch => api.getAll().then((snapshot) => {
    const {docs} = snapshot

    return dispatch({
      type: GET_PRODUCTS,
      payload: docs.map(doc => ({...doc.data(), id: doc.id})),
    })
  })
}

export function setProductsSearchText(event) {
  return {
    type: SET_PRODUCTS_SEARCH_TEXT,
    searchText: event.target.value,
  }
}



// WEBPACK FOOTER //
// ./src/main/content/store/actions/products.actions.js